import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Premiumcabrentalinpune() {



  const cardData =
  {
    keyword: 'Premium Cab Rentals in Pune',
    heading: 'Aaryan Travels: Premium Cab Rentals in Pune',
    headingDescription: 'Aaryan Travels offers Premium Cab Rentals in Pune for executives, families, and travelers who prefer added comfort and class during their journey. Whether it’s an airport transfer from Pune International Airport, a corporate ride to Hinjewadi, or a weekend trip to Lonavala or Mahabaleshwar, our fleet of high-quality sedans, SUVs, and luxury vehicles—including Innova Crysta, Honda City, and Mercedes—ensures a smooth and stylish travel experience. With professional chauffeurs, well-maintained vehicles, and 24/7 service availability, Aaryan Travels delivers premium cab rentals across Koregaon Park, Kalyani Nagar, Baner, and Magarpatta with complete reliability and convenience.',

    top: 'Top Places to Visit in Pune with Aaryan Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort and a symbol of Maratha pride. Once the royal residence of Bajirao I, it features grand gateways like the Delhi Darwaza, sprawling courtyards, and fortified walls. Though partially destroyed by fire, its ruins still echo tales of valor and legacy. The evening light-and-sound show brings history to life. Shaniwar Wada is Pune’s majestic reminder of its glorious past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a historic monument closely linked to India’s freedom movement. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum displaying their personal belongings and photographs. The serene lawns and Italian-style arches add charm. Aga Khan Palace is Pune’s beautiful tribute to patriotism and peace."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual landmark dedicated to Lord Ganesha. The idol, adorned with gold and precious ornaments, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the heart of grand celebrations. Its aura of faith and devotion is unmatched. Dagdusheth Ganpati is Pune’s soulful center of divine blessings."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a hill, Sinhagad Fort is famed for the heroic Battle of 1670 fought by Tanaji Malusare. Trekkers and history enthusiasts climb the scenic trails to enjoy panoramic views of the Sahyadri mountains. Local villagers serve traditional pithla-bhakri at the top. The fort’s bastions and memorials reflect Maratha bravery. Sinhagad is Pune’s blend of adventure, history, and nature."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century monolithic rock-cut shrine dedicated to Lord Shiva. Carved from a single basalt stone, it features massive pillars and a circular Nandi mandapam. Despite being located near a busy road, it offers peace and spirituality. Its ancient architecture fascinates historians and pilgrims alike. Pataleshwar is Pune’s hidden sanctuary of heritage."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, reflecting India’s everyday life and artistic legacy. Exhibits include musical instruments, sculptures, ornaments, and household antiques. The reconstructed Mastani Mahal is a major attraction. It captivates history lovers and students. The museum is Pune’s cultural time capsule."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest heritage sites offering panoramic views of the city. The hilltop temple dedicated to Lord Shiva and Goddess Parvati was built during the Peshwa era. Visitors climb 103 steps to reach the sacred spot. Smaller temples and a museum add cultural richness. Parvati Hill is Pune’s peaceful fusion of devotion and scenic beauty."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene retreat for wellness and self-discovery. Spread across lush gardens and zen-themed architecture, it offers meditation programs, therapy sessions, and peaceful stays. Visitors from around the world seek tranquility here. Osho Ashram is Pune’s global hub of mindfulness and healing."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, arched bridges, stone pathways, and manicured lawns. Families and photographers love its serene beauty. Seasonal flowers make it visually delightful year-round. The garden is Pune’s refreshing escape into nature."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, located on the Mutha River, is a popular spot for evening drives and monsoon outings. The reservoir surrounded by hills looks stunning during sunrise and sunset. Local vendors selling hot corn and tea add to its charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s favorite lakeside retreat."
  }
],



"services": [
  {
    "name": "Premium Cab Rentals in Pune",
    "description": "Premium Cab Rentals in Pune provide a seamless blend of comfort, class, and reliability for both corporate and personal travel. Featuring a fleet of luxury sedans and SUVs, this service caters to executives, business travelers, and clients who appreciate high-end travel experiences. With professional chauffeurs, punctual service, and immaculate vehicles, Premium Cab Rentals in Pune ensure every journey reflects sophistication and quality."
  },
  {
    "name": "Executive Car Hire Pune",
    "description": "Executive Car Hire Pune offers well-maintained, luxury vehicles ideal for senior professionals, VIP guests, and corporate travel. The service emphasizes punctuality, privacy, and professionalism, ensuring that business meetings and airport transfers are conducted with utmost comfort and efficiency."
  },
  {
    "name": "Chauffeur Driven Premium Taxi Pune",
    "description": "Chauffeur Driven Premium Taxi Pune delivers first-class travel with experienced chauffeurs trained in corporate etiquette. Designed for clients seeking style and relaxation, these taxis ensure smooth rides, personalized service, and top-notch comfort throughout the journey."
  },
  {
    "name": "Business Class Cab Pune",
    "description": "Business Class Cab Pune provides an elevated travel experience for business executives and professionals. With a focus on time management, cleanliness, and premium interiors, this service ensures efficient and stress-free commuting for meetings, conferences, and corporate events."
  },
  {
    "name": "Luxury Sedan/SUV Pune",
    "description": "Luxury Sedan/SUV Pune offers an exclusive selection of top-brand vehicles, including elegant sedans and spacious SUVs. These cars are equipped with modern amenities, making them ideal for corporate transfers, family travel, and VIP events in and around Pune."
  },
  {
    "name": "Corporate Premium Cab Pune",
    "description": "Corporate Premium Cab Pune specializes in high-quality transportation solutions for companies and executives. The service provides customized plans, reliable scheduling, and a luxurious fleet to ensure professional mobility for business operations and client travel."
  },
  {
    "name": "Best Premium Cab Services Pune",
    "description": "Best Premium Cab Services Pune stands out for its exceptional quality, trained drivers, and consistent performance. Whether it’s airport transfers, city tours, or executive meetings, the service guarantees superior comfort and reliability every time."
  },
  {
    "name": "Affordable Premium Taxi Pune",
    "description": "Affordable Premium Taxi Pune combines luxury and affordability, making it ideal for travelers seeking premium rides at reasonable prices. The service maintains high standards of safety, comfort, and customer care, ensuring value for every trip."
  },
  {
    "name": "Online Premium Cab Booking Pune",
    "description": "Online Premium Cab Booking Pune offers a user-friendly platform to book luxury cabs instantly. With transparent pricing, real-time tracking, and dedicated support, it simplifies premium travel planning for both individual and corporate users."
  },
  {
    "name": "High-End Cab Rentals Pune",
    "description": "High-End Cab Rentals Pune delivers elite transportation options featuring top-class vehicles and expert chauffeurs. This service is perfect for those who value exclusivity, comfort, and a refined travel experience across Pune and nearby destinations."
  },
  {
    "name": "Prestige Transport Pune",
    "description": "Prestige Transport Pune provides luxury mobility solutions for corporate leaders, VIP guests, and private clients. Known for its punctuality, vehicle quality, and elegant presentation, this service reflects excellence in every ride."
  },
  {
    "name": "Wedding Premium Cab Pune",
    "description": "Wedding Premium Cab Pune offers luxurious and stylish cabs designed for weddings and related events. From bridal entries to guest transfers, the service ensures every ride adds grace and grandeur to the celebration."
  },
  {
    "name": "Premium Airport Taxi Pune",
    "description": "Premium Airport Taxi Pune delivers efficient and comfortable airport transfers with luxury cars and courteous chauffeurs. Clients can expect timely pickups, smooth rides, and a professional experience from doorstep to departure gate."
  },
  {
    "name": "Event Cab Hire Pune",
    "description": "Event Cab Hire Pune provides tailored cab services for corporate gatherings, weddings, and special occasions. The service includes coordinated logistics, professional chauffeurs, and luxury vehicles to ensure seamless group transportation."
  },
  {
    "name": "Pune Elite Cab Services",
    "description": "Pune Elite Cab Services represent the finest in premium transportation, offering a curated selection of high-end vehicles with elite chauffeur service. Whether for corporate, social, or personal use, clients experience unmatched class and comfort."
  }
],
"tableData": [
  ["Premium Cab Rentals in Pune", "Executive Car Hire Pune"],
  ["Chauffeur Driven Premium Taxi Pune", "Business Class Cab Pune"],
  ["Luxury Sedan/SUV Pune", "Corporate Premium Cab Pune"],
  ["Best Premium Cab Services Pune", "Affordable Premium Taxi Pune"],
  ["Online Premium Cab Booking Pune", "High-End Cab Rentals Pune"],
  ["Prestige Transport Pune", "Wedding Premium Cab Pune"],
  ["Premium Airport Taxi Pune", "Event Cab Hire Pune"],
  ["Pune Elite Cab Services", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Premium Cab Rentals in Pune",
    "WhyChoosedescription": "Aaryan Travels offers premium cab rentals in Pune, providing comfortable and stylish travel solutions for business and leisure."
  },
  {
    "WhyChooseheading": "Wide Range of Premium Vehicles",
    "WhyChoosedescription": "Choose from a fleet of well-maintained premium cars that suit your style and travel needs."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our courteous drivers ensure safe, punctual, and comfortable rides across Pune."
  },
  {
    "WhyChooseheading": "Sanitized and Comfortable Cabs",
    "WhyChoosedescription": "All vehicles are regularly cleaned and sanitized to guarantee a hygienic and pleasant journey."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy upfront pricing inclusive of fuel, tolls, and driver allowances without any surprise fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Select hourly, daily, or long-term rental options tailored to your schedule and preferences."
  },
  {
    "WhyChooseheading": "Reliable and Timely Service in Pune",
    "WhyChoosedescription": "We ensure prompt pickups and drop-offs for a smooth and hassle-free travel experience."
  }
]





















  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer premium cab rentals in Pune?',
    answer: 'Yes, Aaryan Travels provides top-quality premium cab rentals in Pune with well-maintained vehicles and professional service.',
  },
  {
    question: 'How can I book premium cab rentals in Pune with Aaryan Travels?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team in Pune.',
  },
  {
    question: 'What types of premium vehicles are available for cab rentals in Pune?',
    answer: 'Aaryan Travels offers a fleet of premium sedans, SUVs, and luxury cars such as BMW, Mercedes, and Audi for cab rentals in Pune.',
  },
  {
    question: 'Are the drivers trained and experienced for premium cab rentals in Pune?',
    answer: 'Absolutely. Our drivers are professionally trained, punctual, and committed to delivering a safe and premium travel experience.',
  },
  {
    question: 'Can premium cab rentals in Pune be used for both corporate and personal travel?',
    answer: 'Yes, our premium cab rentals are ideal for corporate meetings, airport transfers, weddings, and personal trips in Pune.',
  },
  {
    question: 'Is the premium cab rental service available 24x7 in Pune?',
    answer: 'Yes, Aaryan Travels offers round-the-clock premium cab rental services to match your travel needs in Pune.',
  },
  {
    question: 'Are safety and hygiene protocols followed for premium cab rentals?',
    answer: 'All premium vehicles are thoroughly sanitized and our drivers follow strict safety and hygiene protocols.',
  },
  {
    question: 'What payment options are accepted for premium cab rentals in Pune?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate accounts.',
  },
  {
    question: 'Is customer support available during the premium cab rental period in Pune?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your premium cab rental experience.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Deshpande',
    feedback: 'Aaryan Travels delivered an exceptional premium cab rental experience in Pune. Comfortable ride and courteous driver.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Meera Kulkarni',
    feedback: 'Highly recommend Aaryan Travels for premium cab rentals in Pune. Smooth booking and excellent service.',
    rating: 5,
  },
];




























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];








const premiumCabPuneSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Premium Cab Rentals in Pune",
  "description": "Aaryan Travels offers premium cab rentals in Pune including executive car hire, chauffeur driven premium taxis, luxury sedans and SUVs, corporate and wedding cab services.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "serviceType": "Premium Cab Rental",
  "keywords": "Premium Cab Rentals in Pune, Executive Car Hire Pune, Chauffeur Driven Premium Taxi Pune, Business Class Cab Pune, Luxury Sedan/SUV Pune, Corporate Premium Cab Pune, Best Premium Cab Services Pune, Affordable Premium Taxi Pune, Online Premium Cab Booking Pune, High-End Cab Rentals Pune, Prestige Transport Pune, Wedding Premium Cab Pune, Premium Airport Taxi Pune, Event Cab Hire Pune, Pune Elite Cab Services"
};







  return (
    <div>
<Helmet>
  <title>Premium Cab Rentals in Pune | Executive & Luxury Taxi Services | Aaryan Travels</title>
  <meta
    name="description"
    content="Book premium cab rentals in Pune with Aaryan Travels. Executive car hire, luxury sedans and SUVs, chauffeur-driven taxis for business, weddings, airport, and events."
  />
  <meta
    name="keywords"
    content="Premium Cab Rentals in Pune, Executive Car Hire Pune, Chauffeur Driven Premium Taxi Pune, Business Class Cab Pune, Luxury Sedan/SUV Pune, Corporate Premium Cab Pune, Best Premium Cab Services Pune, Affordable Premium Taxi Pune, Online Premium Cab Booking Pune, High-End Cab Rentals Pune, Prestige Transport Pune, Wedding Premium Cab Pune, Premium Airport Taxi Pune, Event Cab Hire Pune, Pune Elite Cab Services"
  />
  <script type="application/ld+json">
    {JSON.stringify(premiumCabPuneSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/97.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Premiumcabrentalinpune;